import { c as _c } from "react/compiler-runtime";
import React, { FC } from "react";
import Link from "next/link";
import { SwitchLanguage } from "@components/app/switch-language/switch-language";
import { ThemeSwitcher } from "@components/app/theme/theme-switcher";
import { PageBreadcrumb } from "@components/page/page-breadcrumb";
import { buildPageHeaderUtilityActions } from "@components/page/page-header-utility-actions";
import { ButtonWithTooltip } from "@components/ui/custom/button-with-tooltip";
import { Separator } from "@components/ui/separator";
import { SidebarTrigger } from "@components/ui/sidebar";
import { NotificationContainer } from "@features/notifications/components/notification-container";
interface PageHeaderProps {
  isLogged?: boolean;
  showDesignSystemUtilityAction?: boolean;
}
export const PageHeader: FC<PageHeaderProps> = t0 => {
  const $ = _c(28);
  const {
    isLogged,
    showDesignSystemUtilityAction: t1
  } = t0;
  const showDesignSystemUtilityAction = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== isLogged || $[1] !== showDesignSystemUtilityAction) {
    const utilityActions = buildPageHeaderUtilityActions({
      showDesignSystem: showDesignSystemUtilityAction
    });
    t5 = "flex h-16 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12";
    let t7;
    if ($[7] !== isLogged) {
      t7 = isLogged && <><SidebarTrigger className="-ml-1" /><Separator orientation="vertical" className="mr-2 data-[orientation=vertical]:h-4" /></>;
      $[7] = isLogged;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <PageBreadcrumb />;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    if ($[10] !== t7) {
      t6 = <div className="flex min-w-0 items-center gap-2 px-4">{t7}{t8}</div>;
      $[10] = t7;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t4 = "ml-auto px-3";
    t2 = "flex items-center gap-2 text-sm";
    t3 = utilityActions.map(_temp);
    $[0] = isLogged;
    $[1] = showDesignSystemUtilityAction;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator orientation="vertical" className="-mr-2 hidden data-[orientation=vertical]:h-4 md:block" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isLogged) {
    t8 = <NotificationContainer isLogged={isLogged} />;
    $[13] = isLogged;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t10;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ThemeSwitcher />;
    t10 = <SwitchLanguage />;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t8) {
    t11 = <div className={t2}>{t3}{t7}{t8}{t9}{t10}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t4) {
    t12 = <div className={t4}>{t11}</div>;
    $[21] = t11;
    $[22] = t4;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t5 || $[26] !== t6) {
    t13 = <header className={t5}>{t6}{t12}</header>;
    $[24] = t12;
    $[25] = t5;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
function _temp(action) {
  return <ButtonWithTooltip key={action.id} tooltipContent={action.label} variant="outline" asChild={true} size="icon" className={action.headerClassName}><Link href={action.href} aria-label={action.ariaLabel}><action.Icon /></Link></ButtonWithTooltip>;
}